import { render, staticRenderFns } from "./BenefitHub.vue?vue&type=template&id=fb72baf0&scoped=true"
import script from "./BenefitHub.vue?vue&type=script&lang=js"
export * from "./BenefitHub.vue?vue&type=script&lang=js"
import style0 from "./BenefitHub.vue?vue&type=style&index=0&id=fb72baf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb72baf0",
  null
  
)

export default component.exports